import * as getters from "./poi.getters";
import * as actions from "./poi.actions";
import * as mutations from "./poi.mutations";

const state = {
    selectedPOIs: [],
    loadingPOIs: [],
    poiLoading: false,
    poiResults: {},
    activePoiId: false,
    customActivePoiType: false,
    customActivePoiSubType: false,
    trafficPOIselected: false,
    isNearbyStationsListOpen: false,
    myOeamtcBase: false,
    poiPaginationData: {},
    poiSorting: false,
    poiApiErrors: {},
    poiToRemoveFromMap: false,
    previousActivePoi: false,
    dynamicPoiElements: {},
}

export default {
    namespaced: false,
    state,
    getters,
    actions,
    mutations
}